// import type { DocProf } from "@/types/DocEditorResponse";
import { apiService } from "./base-api-service/base-api-service";
import { endPoints, getDocProfileEndPoint } from "./base-url/api-constants";
import { getAuthHeader } from "@/utils/helper";

class DocProfileAPI {
  DocProfileAPI(url: string) {
    return getDocProfileEndPoint(url);
  }

  generateSasUriDownload(blobContainer: string, fileName: string, newFileName: string) {
    const getSasUriDownloadEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.BLOB_DOWNLOAD.replace(":blobContainer", blobContainer)
        .replace(":fileName", fileName)
        .replace(":newFileName", newFileName)}`
    );
    return apiService.get(getSasUriDownloadEndPoint, null, getAuthHeader());
  }

  createDocProfile(userId: string, docProfile: any, isnewsetup: string) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.CREATE_DOCPROFILE.replace(":userid", userId).replace(":isnewsetup", isnewsetup)}`
    );
    return apiService.post(docProfileEndPoint, docProfile, getAuthHeader());
  }

  GetCompleteDocProfile(userId: string) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.GET_COMPLETE_DOCPROFILE.replace(":userid", userId)}`
    );
    return apiService.get(docProfileEndPoint, null, getAuthHeader());
  }

  GetDocProfile(userId: string, docId: string, config?: { skipErrorPopup?: boolean }) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.GET_DOCPROFILE.replace(":userid", userId).replace(":docid", docId)}`
    );
    return apiService.get(docProfileEndPoint, null, getAuthHeader(), {
      skipErrorPopup: config?.skipErrorPopup ?? false,
    });
  }

  UpdateDocProfile(userId: string, docProfile: any) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.UPDATE_DOCPROFILE.replace(":userid", userId)}`
    );
    return apiService.put(docProfileEndPoint, docProfile, getAuthHeader());
  }
  createMultipleDocProfile(userId: string, docProfile: any, isnewsetup: string) {
    const docProfileEndPoint = this.DocProfileAPI(
      `${endPoints.docProfileService.MULTIPLE_DOCPROFILE.replace(":userid", userId).replace(":isnewsetup", isnewsetup)}`
    );
    return apiService.post(docProfileEndPoint, docProfile, getAuthHeader());
  }
}

export default new DocProfileAPI();
